// @ts-ignore
/* eslint-disable */
import request from '../../utils/request';

/** 获取合同投顾老师 GET /content/contract-advisor/info */
export async function contentContractAdvisorInfoUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.contentContractAdvisorInfoUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultstring>('/content/contract-advisor/info', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}
